/**
 * Jaipur Handloom search, catalog and variant controller — 18AE10
 * File: jh-20-search-collection.js
 * Purpose: Predictive search, Ajax collection filters, infinite loading and the sole product-variant controller.
 * Dependencies: jh-00-core.js and the existing data-jh-* markup.
 * Maintenance: Search, collection filtering and product option changes must be extended here; do not append replacement controllers.
 */
(function() {
  'use strict';

  function qs(s, r) {
    return (r || document).querySelector(s);
  }

  function qsa(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }

  function esc(v) {
    return String(v || '').replace(/[&<>"']/g, function(ch) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      } [ch];
    });
  }

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    } catch (e) {}
    return ((cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function forceProductSearch() {
    if (!qs('.jh-search-page-v1313')) return;
    var url = new URL(location.href);
    if (url.pathname.indexOf('/search') > -1 && url.searchParams.get('q') && url.searchParams.get('type') !== 'product') {
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      location.replace(url.toString());
    }
  }

  function initSearchSuggestions() {
    qsa('[data-jh-search-root]').forEach(function(root) {
      if (root.dataset.jhPredictiveSearchReady === 'true') return;
      root.dataset.jhPredictiveSearchReady = 'true';

      var input = qs('[data-jh-search-input]', root),
        form = qs('[data-jh-search-form]', root),
        panel = qs('[data-jh-search-panel]', root),
        side = qs('[data-jh-popular-searches]', root),
        box = qs('[data-jh-search-results]', root),
        collectionScript = qs('[data-jh-search-collections]', root),
        discoveryScript = qs('[data-jh-search-discovery]', root),
        featuredScript = qs('[data-jh-search-featured-products]', root),
        popularCollectionsScript = qs('[data-jh-search-popular-collections]', root),
        quickScript = qs('[data-jh-search-quick]', root);
      if (!input || !panel || !side || !box || !collectionScript) return;

      var routeConfig = (window.JHConfig && window.JHConfig.routes) || {};
      var searchBase = routeConfig.search || '/search';
      var predictiveBase = routeConfig.predictiveSearch || '/search/suggest';
      var collections = [], discovery = [], featuredProducts = [], popularCollections = [], quickLinks = [];
      try { collections = JSON.parse(collectionScript.textContent || '[]') || []; } catch (e) {}
      try { discovery = JSON.parse(discoveryScript && discoveryScript.textContent || '[]') || []; } catch (e) {}
      try { featuredProducts = JSON.parse(featuredScript && featuredScript.textContent || '[]') || []; } catch (e) {}
      try { popularCollections = JSON.parse(popularCollectionsScript && popularCollectionsScript.textContent || '[]') || []; } catch (e) {}
      try { quickLinks = JSON.parse(quickScript && quickScript.textContent || '[]') || []; } catch (e) {}
      // The displayed assortment is chosen by Shopify Admin, never by code-defined product categories.
      collections = collections.filter(function(c) { return c && c.url; });
      var collectionIndex = {};
      collections.forEach(function(c){ if (c && c.handle) collectionIndex[c.handle] = c; });
      var discoveryGroups = (discovery || []).map(function(group){
        var items = (group.items || []).map(function(item){
          var c = collectionIndex[item.handle];
          if (!c && !item.url) return null;
          return {label:item.label || (c && c.title) || '', handle:item.handle, swatch:item.swatch || '', swatchKey:item.swatch_key || '', url:item.url || c.url, count:(c && c.count) || 0};
        }).filter(Boolean);
        return {label:group.label || '', items:items};
      }).filter(function(group){ return group.items.length; });

      var labels = {
        products: root.dataset.jhSearchProductsHeading || 'Products',
        loading: root.dataset.jhSearchLoadingLabel || 'Searching…',
        noProducts: root.dataset.jhSearchNoProductsLabel || 'No matching products found.',
        viewAll: root.dataset.jhSearchViewAllLabel || '',
        explore: root.dataset.jhSearchExploreLabel || '',
        bestsellers: root.dataset.jhSearchDefaultProductsHeading || '',
        popular: root.dataset.jhSearchDefaultCategoriesHeading || '',
        empty: root.dataset.jhSearchDefaultEmpty || '',
        browseProducts: root.dataset.jhSearchBrowseProductsLabel || '',
        browseCategories: root.dataset.jhSearchBrowseCategoriesLabel || '',
        matchingCollections: root.dataset.jhSearchMatchingCollectionsHeading || ''
      };
      var timer = null, controller = null, requestSerial = 0;

      function open() {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        input.setAttribute('aria-expanded', 'true');
      }
      function close() {
        requestSerial += 1;
        clearTimeout(timer);
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        input.setAttribute('aria-expanded', 'false');
        if (controller) { controller.abort(); controller = null; }
      }
      function collectionMatches(q) {
        q = String(q || '').trim().toLowerCase();
        if (!q) return [];
        var words = q.split(/\s+/).filter(function(w){ return w.length > 1; });
        return collections.filter(function(c){
          var text = ((c.title || '') + ' ' + (c.handle || '')).toLowerCase();
          return text.indexOf(q) > -1 || words.every(function(w){ return text.indexOf(w) > -1; }) || words.some(function(w){ return text.indexOf(w) > -1; });
        }).slice(0, 6);
      }
      function uniqueItems(items) {
        var keys = Object.create(null);
        return (items || []).filter(function(item){
          if (!item || !item.url) return false;
          var pathname = String(item.url).split('?')[0].replace(/\/$/, '');
          var id = item.id ? 'id:' + item.id : 'url:' + pathname;
          if (keys[id] || keys['url:' + pathname]) return false;
          keys[id] = true;
          keys['url:' + pathname] = true;
          return true;
        });
      }
      featuredProducts = uniqueItems(featuredProducts);
      popularCollections = uniqueItems(popularCollections);
      quickLinks = uniqueItems(quickLinks);
      // Currency can include escaped Shopify money markup. Decode to plain text,
      // never inject the result as markup or expose <span class=money> in search.
      function cleanPrice(value) {
        if (value == null || value === '') return '';
        if (typeof value === 'number') {
          try { return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style:'currency', currency: (window.JHConfig && window.JHConfig.currency) || 'USD'
          }).format(value / 100); } catch(e) { return String(value); }
        }
        var result = String(value);
        for (var pass = 0; pass < 3; pass++) {
          if (!/[<&]/.test(result)) break;
          var holder = document.createElement('textarea');
          holder.innerHTML = result;
          var decoded = holder.value;
          var doc = new DOMParser().parseFromString(decoded, 'text/html');
          result = (doc.body && doc.body.textContent || decoded).trim();
          if (result === decoded && !/<[a-z][^>]*>/i.test(decoded)) break;
        }
        return result.replace(/\s+/g, ' ').trim();
      }
      function discoveryMenu(activeMatches) {
        var matches = (activeMatches || []).slice(0,4);
        var html = '<div class="jh22-search-side jh23-search-side">';
        if (labels.explore) html += '<strong>' + esc(labels.explore) + '</strong>';
        if (quickLinks.length) {
          html += '<div class="jh23-search-trending">' + quickLinks.slice(0,8).map(function(item){
            return '<a href="' + esc(item.url) + '">' + esc(item.label || item.title || '') + '</a>';
          }).join('') + '</div>';
        }
        discoveryGroups.forEach(function(group,index){
          html += '<details class="jh23-search-group"' + (index === 0 ? ' open' : '') + '><summary><span>' + esc(group.label) + '</span><b aria-hidden="true">+</b></summary><div class="jh23-search-group__items">' + group.items.map(function(item){
            var swatch = '';
            if (typeof item.swatch === 'string' && /^#[0-9a-fA-F]{3,8}$/.test(item.swatch)) {
              swatch = '<i class="jh23-swatch" style="background-color:' + esc(item.swatch) + '" aria-hidden="true"></i>';
            } else if (typeof item.swatchKey === 'string' && /^[a-z0-9-]+$/.test(item.swatchKey)) {
              swatch = '<i class="jh23-swatch jh23-swatch--' + esc(item.swatchKey) + '" aria-hidden="true"></i>';
            }
            return '<a href="' + esc(item.url) + '">' + swatch + '<span>' + esc(item.label) + '</span></a>';
          }).join('') + '</div></details>';
        });
        if (matches.length) {
          html += '<div class="jh22-search-side__divider"></div>';
          if (labels.matchingCollections) html += '<strong>' + esc(labels.matchingCollections) + '</strong>';
          html += matches.map(function(c){
            return '<a class="jh23-search-match" href="' + esc(c.url) + '"><span>' + esc(c.title) + '</span><b aria-hidden="true">→</b></a>';
          }).join('');
        }
        html += '</div>';
        side.innerHTML = html;
      }
      function productCard(p) {
        if (!p || !p.url) return '';
        var image = p.image || p.featured_image || '';
        if (image && typeof image === 'object') image = image.url || image.src || '';
        var media = image ? '<span class="jh22-search-product__media"><img src="' + esc(image) + '" alt="' + esc(p.title || '') + '" loading="lazy"></span>' : '<span class="jh22-search-product__media jh22-search-product__media--empty"></span>';
        var price = cleanPrice(p.price != null ? p.price : (p.price_min != null ? p.price_min : p.from_price));
        return '<a class="jh22-search-product" href="' + esc(p.url) + '">' + media + '<span class="jh22-search-product__copy"><strong>' + esc(p.title || '') + '</strong>' + (price ? '<em>' + esc(price) + '</em>' : '') + '</span></a>';
      }
      function collectionCard(c) {
        if (!c || !c.url) return '';
        var image = c.image;
        return '<a class="jh22-search-category" href="' + esc(c.url) + '">' + (image ? '<img src="' + esc(image) + '" alt="' + esc(c.title || '') + '" loading="lazy">' : '<span></span>') + '<strong>' + esc(c.title || '') + '</strong></a>';
      }
      function renderDefault() {
        discoveryMenu([]);
        var featured = featuredProducts.slice(0,8).map(productCard).join('');
        var popular = popularCollections.slice(0,6).map(collectionCard).join('');
        var browseUrl = root.dataset.jhSearchDefaultProductsUrl || '';
        var sections = '';
        if (featured) {
          sections += '<section class="jh22-search-section"><div class="jh22-search-section__head"><h4>' + esc(labels.bestsellers) + '</h4>' + (browseUrl && labels.browseProducts ? '<a href="' + esc(browseUrl) + '">' + esc(labels.browseProducts) + '</a>' : '') + '</div><div class="jh22-search-product-grid">' + featured + '</div></section>';
        }
        if (popular) {
          sections += '<section class="jh22-search-section"><div class="jh22-search-section__head"><h4>' + esc(labels.popular) + '</h4></div><div class="jh22-search-category-grid">' + popular + '</div></section>';
        }
        box.innerHTML = '<div class="jh22-search-default">' + (sections || '<p class="jh-search-status">' + esc(labels.empty) + '</p>') + '</div>';
        box.setAttribute('aria-busy','false');
      }
      function predictiveJsonUrl(q) {
        var base = String(predictiveBase || '/search/suggest').replace(/\.json$/i,'').replace(/\/+$/,'');
        var url = new URL(base + '.json', window.location.origin);
        url.searchParams.set('q', q);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        return url.toString();
      }
      function normalizePredictiveProducts(data) {
        var products = (((((data || {}).resources || {}).results || {}).products) || []).filter(Boolean);
        return uniqueItems(products.map(function(p){
          var image = p.image || p.featured_image || '';
          if (image && typeof image === 'object') image = image.url || image.src || '';
          return {id:p.id || '', title:p.title || '', url:p.url || '', image:image, price:p.price != null ? p.price : p.price_min};
        }));
      }
      function htmlFallback(q, signal) {
        var url = new URL(searchBase, window.location.origin);
        url.searchParams.set('q', q);
        url.searchParams.set('type','product');
        url.searchParams.set('options[prefix]','last');
        return fetch(url.toString(), {signal:signal, credentials:'same-origin', headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){
          if (!r.ok) throw new Error('Search fallback failed');
          return r.text();
        }).then(function(html){
          var doc = new DOMParser().parseFromString(html,'text/html');
          return qsa('[data-jh-product-card],.jh-v200-card',doc).slice(0,6).map(function(card){
            var a = qs('h3 a,.jh-v200-card__body h3 a,a.jh-v200-card__media',card);
            var img = qs('img',card);
            var price = qs('.jh-v200-card__price,.jh-price',card);
            return {title:(a && a.textContent || '').trim(), url:(a && a.getAttribute('href')) || '#', image:(img && (img.currentSrc || img.src)) || '', price:(price && price.textContent || '').trim()};
          }).filter(function(p){ return p.title; });
        });
      }
      function requestProducts(q, signal) {
        return fetch(predictiveJsonUrl(q), {signal:signal, credentials:'same-origin', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
          .then(function(response){ if (!response.ok) throw new Error('Predictive search failed'); return response.json(); })
          .then(function(data){ var products = normalizePredictiveProducts(data); return products.length ? products : htmlFallback(q,signal); })
          .catch(function(error){ if (error && error.name === 'AbortError') throw error; return htmlFallback(q,signal); });
      }
      function renderQuery(q, products, loading) {
        var cs = collectionMatches(q);
        discoveryMenu(cs);
        var html = loading ? '<p class="jh-search-status">' + esc(labels.loading) + '</p>' : (products.length ? '<div class="jh22-search-product-grid">' + products.slice(0,4).map(productCard).join('') + '</div>' : '<p class="jh-search-status">' + esc(labels.noProducts) + '</p>');
        box.innerHTML = '<div class="jh22-search-query"><section class="jh22-search-section"><div class="jh22-search-section__head"><h4>' + esc(labels.products) + '</h4><a href="' + esc(searchBase) + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">' + esc(labels.viewAll) + '</a></div>' + html + '</section></div>';
        box.setAttribute('aria-busy', loading ? 'true' : 'false');
      }
      function update() {
        var q = input.value.trim();
        open();
        if (!q) { renderDefault(); return; }
        var serial = ++requestSerial;
        renderQuery(q, [], true);
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        requestProducts(q, controller ? controller.signal : undefined).then(function(products){
          if (serial !== requestSerial || q !== input.value.trim()) return;
          renderQuery(q, uniqueItems(products || []), false);
        }).catch(function(error){
          if (!error || error.name !== 'AbortError') { if (serial === requestSerial) renderQuery(q, [], false); }
        });
      }

      // QA34: mobile discovery and filters use distinct modes. Never return focus
      // to the text input when the visitor opens a filter accordion.
      var refineToggle = qs('[data-jh34-filter-toggle]', panel);
      var closeMobileButton = qs('[data-jh34-search-close]', panel);
      if (refineToggle) refineToggle.addEventListener('click', function(event) {
        if (window.innerWidth > 900) return;
        event.preventDefault();
        var expanded = !panel.classList.contains('jh34-filters-open');
        panel.classList.toggle('jh34-filters-open', expanded);
        refineToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded) input.blur();
      });
      if (closeMobileButton) closeMobileButton.addEventListener('click', function(event) {
        if (window.innerWidth > 900) return;
        event.preventDefault();
        panel.classList.remove('jh34-filters-open');
        if (refineToggle) refineToggle.setAttribute('aria-expanded', 'false');
        root.dataset.jhSearchDismissed = 'true';
        root.classList.remove('jh-search-has-query');
        close(); input.blur();
      });
      panel.addEventListener('click', function(event) {
        if (window.innerWidth > 900) return;
        if (event.target.closest && event.target.closest('summary')) input.blur();
      });
      input.addEventListener('focus', update);
      input.addEventListener('click', update);
      input.addEventListener('pointerdown', function(){ if (!panel.classList.contains('is-open')) setTimeout(update, 0); });
      input.addEventListener('input', function(){ clearTimeout(timer); timer = setTimeout(update, 140); });
      input.addEventListener('keydown', function(event){ if (event.key === 'Escape') { close(); input.blur(); } });
      if (form) form.addEventListener('submit', function(){ /* normal Shopify search */ });
      document.addEventListener('pointerdown', function(event){ if (!root.contains(event.target)) close(); }, true);
      panel.addEventListener('pointerdown', function(event){ event.stopPropagation(); });
      window.addEventListener('resize', function(){ if (window.innerWidth < 520) close(); });
      panel.setAttribute('aria-hidden','true');
      input.setAttribute('aria-expanded','false');
      renderDefault();
    });
  }

  function initInfiniteLoading() {
    qsa('[data-jh-load-more]').forEach(function(link) {
      if (link.dataset.jhInfiniteBound === '1') return;
      var clean = link.cloneNode(true);
      link.parentNode.replaceChild(clean, link);
      link = clean;
      link.dataset.jhInfiniteBound = '1';
      var loading = false,
        done = false,
        prefetched = null,
        prefetchUrl = '';
      var wrap = link.closest('.jh-load-more-wrap');

      function getGrid(doc) {
        return qs('[data-jh-product-grid]', doc);
      }

      function getNext(doc) {
        return qs('[data-jh-load-more]', doc);
      }

      function getAfter(doc) {
        return qs('[data-jh-after-results]', doc);
      }

      function prefetch() {
        if (done || loading) return;
        var url = link.getAttribute('href');
        if (!url || prefetchUrl === url) return;
        prefetchUrl = url;
        fetch(url, {
          credentials: 'same-origin'
        }).then(function(r) {
          return r.ok ? r.text() : null;
        }).then(function(html) {
          if (html) prefetched = html;
        }).catch(function() {
          prefetchUrl = '';
        });
      }

      function load() {
        if (done || loading) return;
        loading = true;
        if (wrap) wrap.classList.add('is-loading');
        link.textContent = 'Loading more products';
        var url = link.getAttribute('href');
        var htmlPromise = prefetched && prefetchUrl === url ? Promise.resolve(prefetched) : fetch(url, {
          credentials: 'same-origin'
        }).then(function(r) {
          return r.ok ? r.text() : null;
        });
        prefetched = null;
        prefetchUrl = '';
        htmlPromise.then(function(html) {
          if (!html) {
            throw new Error('empty');
          }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = getGrid(doc),
            grid = qs('[data-jh-product-grid]');
          if (newGrid && grid) {
            grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
          }
          var next = getNext(doc);
          if (next && next.getAttribute('href')) {
            link.setAttribute('href', next.getAttribute('href'));
            link.textContent = 'Loading more products…';
            loading = false;
            if (wrap) wrap.classList.remove('is-loading');
            setTimeout(prefetch, 150);
          } else {
            done = true;
            if (wrap) wrap.remove();
            qsa('[data-jh-after-results]').forEach(function(el) {
              el.hidden = false;
            });
            var after = getAfter(doc);
            if (after) {
              var current = qs('[data-jh-after-results]');
              if (current) current.innerHTML = after.innerHTML;
            }
          }
        }).catch(function() {
          loading = false;
          if (wrap) wrap.classList.remove('is-loading');
          link.textContent = 'Load more products';
        });
      }
      link.addEventListener('click', function(e) {
        e.preventDefault();
        load();
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              prefetch();
              setTimeout(load, 250);
            }
          });
        }, {
          rootMargin: '900px 0px'
        });
        io.observe(link);
      } else {
        window.addEventListener('scroll', function() {
          var r = link.getBoundingClientRect();
          if (r.top < window.innerHeight + 800) load();
        }, {
          passive: true
        });
      }
      setTimeout(prefetch, 700);
    });
  }

  function initStickyATC() {
    var bar = qs('[data-jh-sticky-atc]'),
      root = qs('[data-jh-product-root]');
    if (!bar || !root) return;
    var mainVariant = qs('[data-jh-variant-id]', root),
      mainQty = qs('[data-jh-product-qty]', root),
      stickyVariant = qs('[data-jh-sticky-variant-id]', bar),
      stickyQty = qs('[data-jh-sticky-qty]', bar),
      buy = qs('[data-jh-sticky-buy-now]', bar),
      price = qs('[data-jh-sticky-price]', bar),
      priceSource = qs('[data-jh-product-price]', root);

    function sync() {
      if (mainVariant && stickyVariant) stickyVariant.value = mainVariant.value;
      if (mainQty && stickyQty) stickyQty.value = Math.max(parseInt(mainQty.value || '1', 10) || 1, 1);
      if (buy && stickyVariant) {
        var rootUrl = (window.JH && window.JH.Utils) ? window.JH.Utils.rootUrl() : '/';
        buy.href = rootUrl + 'cart/' + encodeURIComponent(stickyVariant.value) + ':' + (stickyQty ? stickyQty.value : 1) + '?checkout';
      }
      if (price && priceSource) {
        price.textContent = priceSource.textContent.replace(/\s+/g, ' ').trim();
      }
    }
    ['change', 'input', 'click'].forEach(function(ev) {
      root.addEventListener(ev, function() {
        setTimeout(sync, 30);
      });
    });
    sync();
    var anchor = qs('.jh-product-form', root) || root;

    function reveal() {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0 || window.scrollY > 520);
    }
    window.addEventListener('scroll', reveal, {
      passive: true
    });
    window.addEventListener('resize', reveal);
    reveal();
  }

  function boot() {
    forceProductSearch();
    initSearchSuggestions();
    initInfiniteLoading();
    initStickyATC();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();;
(function() {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function closeFilterDrawer(section) {
    section.classList.remove('jh-filter-drawer-open');
    var btn = qs('[data-jh-filter-open]', section);
    if (btn) btn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('jh-filter-drawer-open');
  }

  function openFilterDrawer(section) {
    section.classList.add('jh-filter-drawer-open');
    var btn = qs('[data-jh-filter-open]', section);
    if (btn) btn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('jh-filter-drawer-open');
  }

  function cleanFormData(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    data.forEach(function(value, key) {
      if (value !== null && String(value).trim() !== '') params.append(key, value);
    });
    return params;
  }

  function setLoading(section, on) {
    var box = qs('[data-jh-collection-results]', section);
    if (box) box.classList.toggle('is-loading', !!on);
  }

  function swapCollectionHtml(section, html, url) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-jh-collection-section]', doc);
    if (!fresh) {
      location.href = url;
      return;
    }
    var selectors = ['[data-jh-collection-results]', '[data-jh-active-filter-row]', '[data-jh-filter-drawer]', '.jh-collection-head-v1314'];
    selectors.forEach(function(sel) {
      var oldEl = qs(sel, section),
        newEl = qs(sel, fresh);
      if (oldEl && newEl) {
        oldEl.replaceWith(newEl);
      }
    });
    if (window.history && url) {
      window.history.pushState({
        jhCollection: true
      }, '', url);
    }
    section.dataset.jhFiltersReady = '0';
    initCollectionFilters(section);
    if (window.JH && window.JH.Collection && typeof window.JH.Collection.init === 'function') {
      try {
        window.JH.Collection.init();
      } catch (e) {}
    }
    if (typeof window.dispatchEvent === 'function') window.dispatchEvent(new Event('jh:collection:updated'));
  }

  function fetchCollection(section, url) {
    setLoading(section, true);
    fetch(url, {
      credentials: 'same-origin'
    }).then(function(r) {
      return r.ok ? r.text() : Promise.reject(r.status);
    }).then(function(html) {
      swapCollectionHtml(section, html, url);
    }).catch(function() {
      location.href = url;
    }).finally(function() {
      setLoading(section, false);
    });
  }

  function submitFilterForm(section, form) {
    var params = cleanFormData(form);
    var raw = (form && form.getAttribute && form.getAttribute('action')) || location.pathname;
    var base = location.pathname;
    try {
      base = new URL(raw, location.origin).pathname || location.pathname;
    } catch (e) {
      base = String(raw || location.pathname).replace(/\?.*$/, '') || location.pathname;
    }
    var query = params.toString();
    var full = base + (query ? '?' + query : '');
    fetchCollection(section, full);
    closeFilterDrawer(section);
  }

  function initCollectionFilters(scope) {
    var section = (scope && scope.matches && scope.matches('[data-jh-collection-section]')) ? scope : qs('[data-jh-collection-section]', scope || document);
    if (!section || section.dataset.jhFiltersReady === '1') return;
    section.dataset.jhFiltersReady = '1';
    qsa('.jh-filter-mobile-button', section).forEach(function(btn) {
      btn.parentNode && btn.parentNode.removeChild(btn);
    });
    var open = qs('[data-jh-filter-open]', section);
    if (open) {
      open.addEventListener('click', function() {
        openFilterDrawer(section);
      });
    }
    qsa('[data-jh-filter-close]', section).forEach(function(btn) {
      btn.addEventListener('click', function() {
        closeFilterDrawer(section);
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeFilterDrawer(section);
    }, {
      once: false
    });
    var filterForm = qs('[data-jh-filter-form]', section);
    if (filterForm) {
      filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        submitFilterForm(section, filterForm);
      });
      var autoTimer = null;
      qsa('input[type="checkbox"]', filterForm).forEach(function(input) {
        input.addEventListener('change', function() {
          clearTimeout(autoTimer);
          autoTimer = setTimeout(function() {
            submitFilterForm(section, filterForm);
          }, 180);
        });
      });
      qsa('.jh-price-filter-v1314 input', filterForm).forEach(function(input) {
        input.addEventListener('change', function() {
          clearTimeout(autoTimer);
          autoTimer = setTimeout(function() {
            submitFilterForm(section, filterForm);
          }, 260);
        });
      });
    }
    var sortForm = qs('[data-jh-sort-form]', section);
    var sort = qs('[data-jh-sort-select]', section);
    if (sortForm && sort) {
      sort.addEventListener('change', function(e) {
        e.preventDefault();
        var params = new URLSearchParams(location.search);
        params.set('sort_by', sort.value);
        var url = location.pathname + '?' + params.toString();
        fetchCollection(section, url);
      });
    }
    qsa('[data-jh-filter-chip],[data-jh-filter-clear]', section).forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        fetchCollection(section, link.href);
      });
    });
    qsa('[data-jh-filter-browse]', section).forEach(function(link) {
      link.addEventListener('click', function(e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        fetchCollection(section, link.href);
      });
    });
  }


  function improveInfiniteAfterAjax() {
    document.addEventListener('jh:collection:updated', function() {
      setTimeout(function() {
        if (window.JH && window.JH.Collection && typeof window.JH.Collection.init === 'function') {
          try {
            window.JH.Collection.init();
          } catch (e) {}
        }
      }, 50);
    });
  }

  function boot() {
    initCollectionFilters();
    improveInfiniteAfterAjax();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();;
(function() {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
    } catch (e) {}
    var currency = 'USD';
    try {
      currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    } catch (e) {}
    return (Number(cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: currency
    });
  }

  function getSelectedOptions(root) {
    var selected = [];
    qsa('[data-jh-option-group]', root).forEach(function(group) {
      var pos = parseInt(group.getAttribute('data-position'), 10) - 1;
      var sel = qs('[data-jh-option-select]', group);
      var btn = qs('[data-jh-option].is-selected', group) || qs('[data-jh-option]', group);
      if (sel) selected[pos] = sel.value;
      else if (btn) selected[pos] = btn.getAttribute('data-value');
    });
    return selected;
  }

  function findVariant(product, selected) {
    return (product.variants || []).filter(function(v) {
      return (v.options || []).join('||') === selected.join('||');
    })[0] || product.variants && product.variants[0];
  }

  function renderSaleBadges(variant, saleBox) {
    if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) return '';
    var save = variant.compare_at_price - variant.price;
    var pct = Math.round((save * 100) / variant.compare_at_price);
    var ds = (saleBox && saleBox.dataset) || {};

    function enabled(value, fallback) {
      return value === undefined || value === '' ? fallback : String(value) === 'true';
    }
    var html = '';
    if (enabled(ds.jhSaleShowSale, true)) {
      html += '<span class="jh-product-badge jh-product-badge--on-sale">' + (ds.jhSaleLabel || 'SALE') + '</span>';
    }
    if (enabled(ds.jhSaleShowPercent, true)) {
      html += '<span class="jh-product-badge jh-product-badge--percent">' + pct + '% ' + (ds.jhPercentLabel || 'OFF') + '</span>';
    }
    if (enabled(ds.jhSaleShowSave, false)) {
      html += '<span class="jh-product-badge jh-product-badge--save"><span>' + (ds.jhSaveLabel || 'SAVE') + '</span> <span>' + money(save) + '</span></span>';
    }
    return html;
  }

  function renderPrice(variant) {
    if (!variant) return '';
    var html = '<span class="jh-price" data-jh-price-current><span data-jh-current-price>' + money(variant.price) + '</span>';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += ' <s data-jh-compare-price>' + money(variant.compare_at_price) + '</s>';
    }
    html += '</span>';
    return html;
  }

  function initVariantAwareDiscounts(scope) {
    qsa('[data-jh-product-root]', scope || document).forEach(function(root) {
      if (root.dataset.jhVariantReady === 'true') return;
      var jsonEl = qs('[data-jh-product-json]', root);
      if (!jsonEl) return;
      var product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      root.dataset.jhVariantReady = 'true';
      var hidden = qs('[data-jh-variant-id]', root);
      var priceBox = qs('[data-jh-product-price]', root);
      var saleBox = qs('[data-jh-sale-badges]', root);
      var stickyVariant = qs('[data-jh-sticky-variant-id]');
      var stickyPrice = qs('[data-jh-sticky-price]');
      var stickyBuy = qs('[data-jh-sticky-buy-now]');
      var buyNow = qs('[data-jh-buy-now-link]', root);
      var qtyInput = qs('[data-jh-product-qty]', root);

      function cartCheckoutUrl(variantId, quantity) {
        var base = (window.JH && JH.Utils) ? JH.Utils.route('cart/') : '/cart/';
        return base + encodeURIComponent(variantId) + ':' + quantity + '?checkout';
      }

      function update(source) {
        var variant = findVariant(product, getSelectedOptions(root));
        if (!variant) return;
        if (hidden) hidden.value = variant.id;
        if (stickyVariant) stickyVariant.value = variant.id;
        if (priceBox) priceBox.innerHTML = renderPrice(variant);
        if (saleBox) saleBox.innerHTML = renderSaleBadges(variant, saleBox);
        if (stickyPrice) stickyPrice.textContent = money(variant.price);
        var qty = qtyInput ? Math.max(parseInt(qtyInput.value || '1', 10) || 1, 1) : 1;
        if (buyNow) buyNow.href = cartCheckoutUrl(variant.id, qty);
        if (stickyBuy) stickyBuy.href = cartCheckoutUrl(variant.id, qty);

        if (source !== 'initial' && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
        try {
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: variant, product: product, root: root }
          }));
        } catch (e) {}
      }

      qsa('[data-jh-option]', root).forEach(function(button) {
        button.addEventListener('click', function() {
          var group = button.closest('[data-jh-option-group]');
          if (!group) return;
          qsa('[data-jh-option]', group).forEach(function(option) {
            var selected = option === button;
            option.classList.toggle('is-selected', selected);
            option.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          var select = qs('[data-jh-option-select]', group);
          if (select) select.value = button.getAttribute('data-value') || '';
          update('option');
        });
      });

      qsa('[data-jh-option-select]', root).forEach(function(select) {
        select.addEventListener('change', function() {
          var group = select.closest('[data-jh-option-group]');
          if (group) {
            qsa('[data-jh-option]', group).forEach(function(option) {
              var selected = option.getAttribute('data-value') === select.value;
              option.classList.toggle('is-selected', selected);
              option.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
          }
          update('select');
        });
      });

      if (qtyInput) {
        ['change', 'input'].forEach(function(eventName) {
          qtyInput.addEventListener(eventName, function() { update('quantity'); });
        });
      }
      update('initial');
    });
  }


  function boot() {
    initVariantAwareDiscounts(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function(event) {
    initVariantAwareDiscounts(event.target);
  });
})();;

/* Fast Ajax product-card review previews use one body-level tooltip so carousel overflow never clips it. */
(function() {
  'use strict';

  var portal = null;
  var activeTrigger = null;
  var hideTimer = null;
  var requestCache = {};
  var storagePrefix = 'jh_review_preview_v3:';
  var touchTrigger = null;
  var lastPointerType = '';

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function clean(value, limit) {
    value = String(value || '').replace(/\s+/g, ' ').trim();
    if (limit && value.length > limit) value = value.slice(0, limit - 1).trim() + '…';
    return value;
  }

  function ensurePortal() {
    if (portal && document.body.contains(portal)) return portal;
    portal = document.createElement('div');
    portal.className = 'jh-review-preview-portal';
    portal.id = 'JHReviewPreviewPortal';
    portal.setAttribute('role', 'tooltip');
    portal.setAttribute('aria-hidden', 'true');
    portal.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
    portal.addEventListener('mouseleave', scheduleHide);
    portal.addEventListener('click', function(event) {
      if (!activeTrigger || (event.target && event.target.closest && event.target.closest('a, button, input, select'))) return;
      window.location.href = activeTrigger.href;
    });
    document.body.appendChild(portal);
    return portal;
  }

  function reviewUrl(trigger) {
    var value = trigger.getAttribute('data-jh-review-url') || trigger.getAttribute('href') || '';
    try {
      var url = new URL(value, window.location.origin);
      url.hash = '';
      return url.href;
    } catch (error) {
      return String(value || '').split('#')[0];
    }
  }

  function summaryText(trigger) {
    var count = parseInt(trigger.getAttribute('data-jh-review-count'), 10) || 0;
    if (count > 0) return 'Based on ' + count + ' customer review' + (count === 1 ? '' : 's') + '.';
    var badge = clean(trigger.getAttribute('data-jh-review-badge-text'), 140);
    return badge || 'Recent review details are loading.';
  }

  function isTouchInteraction(event) {
    if (event && event.detail === 0) return false;
    if (lastPointerType) return lastPointerType === 'touch' || lastPointerType === 'pen';
    return !!(window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches);
  }

  function actionLabel() {
    return isTouchInteraction() ? 'Tap again to read all reviews' : 'Click to read all reviews';
  }

  function baseMarkup(trigger, loading) {
    var title = trigger.getAttribute('data-jh-review-title') || 'Customer reviews';
    var rating = parseFloat(trigger.getAttribute('data-jh-review-rating')) || 0;
    var count = parseInt(trigger.getAttribute('data-jh-review-count'), 10) || 0;
    var ratingLine = rating > 0 ? rating.toFixed(1) + ' out of 5' + (count ? ' · ' + count + ' reviews' : '') : (count ? count + ' customer reviews' : 'Customer reviews');
    return '<strong>' + esc(title) + '</strong>' +
      '<span class="jh-review-preview-portal__stars" aria-hidden="true">★★★★★</span>' +
      '<span class="jh-review-preview-portal__rating">' + esc(ratingLine) + '</span>' +
      '<span class="jh-review-preview-portal__summary' + (loading ? ' is-loading' : '') + '">' + esc(loading ? 'Loading recent reviews…' : summaryText(trigger)) + '</span>' +
      '<span class="jh-review-preview-portal__action">' + esc(actionLabel()) + '</span>';
  }

  function reviewMarkup(data, trigger) {
    if (!data || !data.reviews || !data.reviews.length) return baseMarkup(trigger, false);
    var html = '<strong>' + esc(trigger.getAttribute('data-jh-review-title') || 'Customer reviews') + '</strong>' +
      '<span class="jh-review-preview-portal__stars" aria-hidden="true">★★★★★</span>';
    if (data.summary) html += '<span class="jh-review-preview-portal__rating">' + esc(data.summary) + '</span>';
    html += '<span class="jh-review-preview-portal__reviews">';
    data.reviews.slice(0, 2).forEach(function(review) {
      html += '<span class="jh-review-preview-portal__review">';
      if (review.title) html += '<b>' + esc(review.title) + '</b>';
      if (review.body) html += '<span>' + esc(review.body) + '</span>';
      if (review.author) html += '<em>— ' + esc(review.author) + '</em>';
      html += '</span>';
    });
    html += '</span><span class="jh-review-preview-portal__action">' + esc(actionLabel()) + '</span>';
    return html;
  }

  function parseReviewPage(htmlText) {
    var parsed = new DOMParser().parseFromString(htmlText, 'text/html');
    var root = parsed.querySelector('#judgeme_product_reviews, .jdgm-review-widget, [data-judgeme-product-reviews], #JHReviews');
    if (!root) return { reviews: [], summary: '' };
    Array.prototype.slice.call(root.querySelectorAll('style, script, noscript, template')).forEach(function(node) {
      node.remove();
    });
    var widget = root.matches('.jdgm-review-widget, [data-judgeme-product-reviews]') ? root : (root.querySelector('.jdgm-review-widget, [data-judgeme-product-reviews]') || root);
    var summaryNode = widget.querySelector('.jdgm-rev-widg__summary-text, .jdgm-prev-badge__text, .jdgm-rev-widg__summary-average');
    var summary = clean(summaryNode && summaryNode.textContent, 120);
    var reviews = Array.prototype.slice.call(widget.querySelectorAll('.jdgm-rev')).slice(0, 2).map(function(node) {
      var title = node.querySelector('.jdgm-rev__title');
      var body = node.querySelector('.jdgm-rev__body, .jdgm-rev__content');
      var author = node.querySelector('.jdgm-rev__author, .jdgm-rev__buyer-badge-wrapper');
      return {
        title: clean(title && title.textContent, 70),
        body: clean(body && body.textContent, 190),
        author: clean(author && author.textContent, 70)
      };
    }).filter(function(review) { return review.title || review.body || review.author; });
    return { reviews: reviews, summary: summary };
  }

  function stored(url) {
    try {
      var raw = sessionStorage.getItem(storagePrefix + url);
      if (!raw) return null;
      var value = JSON.parse(raw);
      if (!value || Date.now() - Number(value.savedAt || 0) > 30 * 60 * 1000) return null;
      return value.data || null;
    } catch (error) { return null; }
  }

  function save(url, data) {
    try { sessionStorage.setItem(storagePrefix + url, JSON.stringify({ savedAt: Date.now(), data: data })); } catch (error) {}
  }

  function load(trigger) {
    var url = reviewUrl(trigger);
    if (!url) return Promise.resolve(null);
    var cached = stored(url);
    if (cached) return Promise.resolve(cached);
    if (requestCache[url]) return requestCache[url];
    requestCache[url] = fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'force-cache'
    }).then(function(response) {
      if (!response.ok) throw new Error('Review preview request failed: ' + response.status);
      return response.text();
    }).then(parseReviewPage).then(function(data) {
      save(url, data);
      return data;
    }).catch(function() {
      return null;
    });
    return requestCache[url];
  }

  function position(trigger) {
    if (!portal || !trigger || !document.body.contains(trigger)) return;
    var rect = trigger.getBoundingClientRect();
    var portalRect = portal.getBoundingClientRect();
    var gap = 8;
    var left = rect.left;
    var top = rect.top - portalRect.height - gap;
    if (top < 8) top = rect.bottom + gap;
    if (top + portalRect.height > window.innerHeight - 8) top = Math.max(8, window.innerHeight - portalRect.height - 8);
    left = Math.max(8, Math.min(left, window.innerWidth - portalRect.width - 8));
    portal.style.left = Math.round(left) + 'px';
    portal.style.top = Math.round(top) + 'px';
  }

  function show(trigger) {
    clearTimeout(hideTimer);
    activeTrigger = trigger;
    var tip = ensurePortal();
    tip.innerHTML = baseMarkup(trigger, true);
    tip.classList.add('is-open');
    tip.setAttribute('aria-hidden', 'false');
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-describedby', tip.id);
    trigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function() { position(trigger); });
    load(trigger).then(function(data) {
      if (trigger !== activeTrigger || !portal) return;
      portal.innerHTML = reviewMarkup(data, trigger);
      requestAnimationFrame(function() { position(trigger); });
    });
  }

  function hide() {
    if (activeTrigger) {
      activeTrigger.classList.remove('is-open');
      activeTrigger.removeAttribute('aria-describedby');
      activeTrigger.setAttribute('aria-expanded', 'false');
    }
    activeTrigger = null;
    if (portal) {
      portal.classList.remove('is-open');
      portal.setAttribute('aria-hidden', 'true');
    }
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 140);
  }

  function delegatedOver(event) {
    if ((event.pointerType && event.pointerType !== 'mouse') || (!event.pointerType && lastPointerType === 'touch')) return;
    var trigger = event.target && event.target.closest && event.target.closest('.jh-card-review-trigger');
    if (!trigger || trigger === activeTrigger) return;
    show(trigger);
  }

  function delegatedOut(event) {
    if ((event.pointerType && event.pointerType !== 'mouse') || (!event.pointerType && lastPointerType === 'touch')) return;
    var trigger = event.target && event.target.closest && event.target.closest('.jh-card-review-trigger');
    if (!trigger) return;
    var next = event.relatedTarget;
    if (next && (trigger.contains(next) || (portal && portal.contains(next)))) return;
    scheduleHide();
  }

  document.addEventListener('pointerdown', function(event) {
    lastPointerType = event.pointerType || '';
    var trigger = event.target && event.target.closest && event.target.closest('.jh-card-review-trigger');
    if (!trigger && !(portal && portal.contains(event.target))) {
      touchTrigger = null;
      hide();
    }
  }, true);
  document.addEventListener('touchstart', function(event) {
    lastPointerType = 'touch';
    var trigger = event.target && event.target.closest && event.target.closest('.jh-card-review-trigger');
    if (!trigger && !(portal && portal.contains(event.target))) {
      touchTrigger = null;
      hide();
    }
  }, { capture: true, passive: true });
  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest && event.target.closest('.jh-card-review-trigger');
    if (!trigger || !isTouchInteraction(event)) return;
    if (touchTrigger !== trigger || !portal || !portal.classList.contains('is-open')) {
      event.preventDefault();
      event.stopPropagation();
      touchTrigger = trigger;
      show(trigger);
      return;
    }
    touchTrigger = null;
  }, true);
  document.addEventListener('mouseover', delegatedOver, true);
  document.addEventListener('mouseout', delegatedOut, true);
  document.addEventListener('pointerover', delegatedOver, true);
  document.addEventListener('pointerout', delegatedOut, true);
  document.addEventListener('focusin', function(event) {
    var trigger = event.target && event.target.closest && event.target.closest('.jh-card-review-trigger');
    if (trigger) show(trigger);
  });
  document.addEventListener('focusout', function(event) {
    var trigger = event.target && event.target.closest && event.target.closest('.jh-card-review-trigger');
    if (trigger) scheduleHide();
  });

  window.addEventListener('scroll', function() { if (activeTrigger) position(activeTrigger); }, { passive: true });
  window.addEventListener('resize', function() { if (activeTrigger) position(activeTrigger); });

  function warmVisiblePreviews() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('.jh-card-review-trigger')).slice(0, 10);
    triggers.forEach(function(trigger, index) {
      window.setTimeout(function() { load(trigger); }, index * 120);
    });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(warmVisiblePreviews, { timeout: 1800 });
  else window.setTimeout(warmVisiblePreviews, 1000);
})();
